import { Output, EventEmitter, OnInit, Input } from '@angular/core';
import { WorkFieldListChangeEvent } from '../../../events/work-field-list-change-event';
import { E5coreUiWorkFieldTypeComponentBase } from '../../../components/e5core-ui-work-field/e5core-ui-work-field-type-component-base';
import { FormControl, Validators } from '@angular/forms';
import { UIListModel } from 'e5core-angular-services';
import { MatSelectChange } from '@angular/material';

export class E5coreUiWorkFieldTypeListBaseComponent extends E5coreUiWorkFieldTypeComponentBase implements OnInit {

	@Output() valueChange = new EventEmitter<WorkFieldListChangeEvent>() ;
	@Input() list : UIListModel[] ;
	@Input() selected : number ;

	//formControl: FormControl ;
	// selected : any ;

	ngOnInit() {
	}

	protected getError(): string {
		let error = '' ;
		// if (this.formControl.hasError('required')) {
		// 	error = 'required' ;
		// }
		return (error) ;
	}

	changeValue($event: MatSelectChange) {
		let error = '' ;
		// if (this.formControl.hasError('required')) {
		// 	error = 'required' ;
		// }
		let event = <WorkFieldListChangeEvent>{
			id : $event.value,
			error: error 
		}
		this.valueChange.emit(event) ;
	}

	blur($event) {
		//this.changeValue(this.formControl.value) ;
	}

}
